import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { MapPin, Phone, Clock } from 'lucide-react';

export default function AlertList({ alerts, selectedId, onSelect, loading }) {
  if (loading) {
    return (
      <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-muted)' }}>
        Loading alerts...
      </div>
    );
  }

  if (alerts.length === 0) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
        <div style={{ fontSize: 32, marginBottom: 8 }}>✓</div>
        <div style={{ fontSize: 13, fontWeight: 600 }}>No active alerts</div>
        <div style={{ fontSize: 12, marginTop: 4 }}>All clear — monitoring for SOS signals</div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 12, fontFamily: 'var(--font-display)' }}>
        {alerts.length} ALERT{alerts.length !== 1 ? 'S' : ''}
      </div>
      {alerts.map(alert => (
        <div
          key={alert.id}
          className={`alert-card ${alert.priority === 'CRITICAL' ? 'critical' : 'high'} ${alert.status === 'pending' ? 'alert-flash' : ''} fade-in`}
          onClick={() => onSelect(alert)}
          style={{
            borderColor: selectedId === alert.id ? 'var(--accent-blue)' : undefined,
            background: selectedId === alert.id ? 'var(--bg-hover)' : undefined
          }}
        >
          <div className="alert-card-header">
            <div className="alert-category">
              <span>{alert.category_icon}</span>
              <span>{alert.category_name}</span>
            </div>
            <span className={`status-badge status-${alert.status}`}>
              {alert.status.replace('_', ' ')}
            </span>
          </div>
          <div className="alert-card-body">
            <div className="alert-user" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ fontWeight: 600 }}>{alert.user_name}</span>
              {alert.user_phone && (
                <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                  <Phone size={10} /> {alert.user_phone}
                </span>
              )}
            </div>
            {alert.address && (
              <div className="alert-location" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <MapPin size={10} /> {alert.address}
              </div>
            )}
            <div className="alert-location" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <Clock size={10} />
              {alert.created_at ? formatDistanceToNow(new Date(alert.created_at), { addSuffix: true }) : 'Just now'}
            </div>
            {alert.trigger_method === 'voice' && (
              <div style={{ fontSize: 10, color: 'var(--accent-cyan)', marginTop: 2, fontFamily: 'var(--font-display)' }}>
                🎤 Voice Triggered: "{alert.trigger_word || 'SOS'}"
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
